import React, { useState } from "react";
import { CONFIG } from "../../../config";
import LeadPopup from "./LeadPopup";

// Solo copertina: al click apre sempre il pop-up lead (niente video inline).
export default function WistiaPlayer() {
  const [open, setOpen] = useState(false);
  return (
    <section id="vsl-player" className="px-4 pt-2 pb-10">
      <div className="mx-auto max-w-[900px] lg:max-w-[1120px]">
        <button
          onClick={() => setOpen(true)}
          className="group block w-full v-card overflow-hidden"
          style={{ padding: 0, cursor: "pointer" }}
          aria-label="Scopri Sales Mastery 1.0"
        >
          <img
            src={CONFIG.VSL_COVER}
            alt="Sales Mastery 1.0 è tornato — HighTicketSales.it"
            className="w-full h-auto block transition-transform group-hover:scale-[1.02]"
            style={{ display: "block" }}
          />
        </button>
      </div>
      <LeadPopup open={open} onOpenChange={setOpen} />
    </section>
  );
}
